module.exports = __webpack_public_path__ + "img/ghonaim-follow.673012eb.webp";